import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
// import { useLocation} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
// import { Carousel } from "react-responsive-carousel";
// import Slider from "react-slick";

// import { getCmsStart } from "../../redux-saga/redux/cms";
import useStyles from "./Footer.styles";
// import CustomImg from "../../container/CustomImg";
import BrandLogo from "../../container/SportsBookNode/BrandLogo";
// import { getProvidersStart } from "../../redux-saga/redux/casino/lobby/casinoLobby";
// import Session from "../../utils/session";
import { BRANDNAME } from "../../utils/constants";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const logos = [
  "/images/logofooter1.png",
  "/images/logofooter2.png",
  "/images/logofooter3.png",
  "/images/logofooter4.png",
  "/images/logofooter5.png",
  "/images/logofooter6.png",
  "/images/logofooter7.png"
];

const Footer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // const location = useLocation();
  const dispatch = useDispatch();
  // const cmsData = useSelector((state) => state.cms.cmsData);
  const classes = useStyles();
  const { isGameStarted } = useSelector((state) => state.casinoGames);
  // const { providers, providerLoading } = useSelector(
  //   (state) => state.casinoLobby
  // );

  const [currentLogo, setCurrentLogo] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLogo((prevIndex) => (prevIndex + 1) % logos.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    // dispatch(getCmsStart({ language: i18n?.language }));
    // dispatch(
    //   getProvidersStart({
    //     userId: Session.getSessionCred?.userId || null,
    //     subCategoryType: "",
    //   })
    // );
  }, [dispatch, i18n.language]);

  if (isGameStarted && isMobile) {
    return;
  }

  // const slidesToShow = isMobile ? 2 : 5;
  // const dots = isMobile ? false : true;
  // var settings = {
  //   slidesToShow: slidesToShow,
  //   slidesToScroll: slidesToShow,
  //   infinite: false,
  //   lazyLoad: true,
  //   dots: dots,
  //   arrows: false,
  //   className: `${classes.providersliderwrap} ${classes.footerSlider}`,
  //   speed: 3000,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   draggable: true,
  //   pauseOnHover: true,
  //   swipeToSlide: true
  //   // responsive: [
  //   //   {
  //   //     breakpoint: 1536,
  //   //     settings: {
  //   //       slidesToShow: 5,
  //   //       slidesToScroll: 5,
  //   //       infinite: false,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 1440,
  //   //     settings: {
  //   //       slidesToShow: 4,
  //   //       slidesToScroll: 7,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 1024,
  //   //     settings: {
  //   //       slidesToShow: 6,
  //   //       slidesToScroll: 5,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 991,
  //   //     settings: {
  //   //       slidesToShow: 5,
  //   //       slidesToScroll: 4,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 768,
  //   //     settings: {
  //   //       slidesToShow: 4,
  //   //       slidesToScroll: 3,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 600,
  //   //     settings: {
  //   //       slidesToShow: 3,
  //   //       slidesToScroll: 2,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 480,
  //   //     settings: {
  //   //       slidesToShow: 2,
  //   //       slidesToScroll: 2,
  //   //     },
  //   //   },
  //   // ],
  // };

  return (
    <div className={classes.footerSection}>
      <Grid className={classes.footerWrap}>
        {/* {location.pathname !== "/" && location.pathname !== "/sports" ? (
          <Grid className={classes.sliderwrap}>
            {!providerLoading ? (
              <Slider {...settings}>
                {providers?.provider?.map((item) => {
                  return (
                    <div key={item?.thumbnailUrl || item?.providerImage}>
                      <Link
                        to={`/casino/view-all/provider/${item.masterCasinoProviderId}/${item.name}`}
                      >
                        <CustomImg
                          origSrc={
                            item.thumbnailUrl
                              ? item.thumbnailUrl
                              : item.providerImage
                          }
                          tempSrc="/images/game-default.webp"
                          fetchPriority=""
                          className={classes.providerimg}
                          height={80}
                          width={100}
                        />
                      </Link>
                    </div>
                  );
                })}
              </Slider>
            ) : (
              <Grid className={`${classes.providersliderwrap}`}>
                <Skeleton variant="rectangular" height={170} />
              </Grid>
            )}
          </Grid>
        ) : null} */}
        <Grid className={classes.footerInstruction}>
          <div
            onClick={() => navigate("/casino/casinoProvider")}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                navigate("/casino/casinoProvider");
              }
            }}
            role="button"
            tabIndex={0}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "90px"
            }}
          >
            <div
              style={{
                display: "flex",
                height: "78px",
                width: "103px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <img
                loading="lazy"
                src="/images/footer5.png"
                alt=""
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            {/* Top rotating logo */}
            <Grid className={classes.footerInstructionLogos}>
              <img
                loading="lazy"
                src={logos[currentLogo]}
                alt={`Footer logo ${currentLogo + 1}`}
                className={classes.logo}
                style={{ transition: "opacity 0.5s ease-in-out" }}
              />
            </Grid>
          </div>
          <div style={{ display: "flex" }}>
            <img
              loading="lazy"
              src="/images/footer3.png"
              alt=""
              width="90"
              height="90"
            />

            <img
              loading="lazy"
              src="/images/footer2.png"
              alt=""
              width="90"
              height="90"
            />
            {/* <Typography>{t("FOOTER.ALL_PLATFORMS")}</Typography> */}

            <img
              loading="lazy"
              src="/images/footer1.png"
              alt=""
              width="90"
              height="90"
            />
          </div>
        </Grid>
      </Grid>
      <Grid className={classes.footerCopyrightSection}>
        <Grid className={classes.footerCopyrightLeft}>
          <BrandLogo />
          <Typography>
            {t("FOOTER.COPYRIGHT_MSG_START") +
              BRANDNAME +
              t("FOOTER.COPYRIGHT_MSG_END")}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
